window.onload = function() {
  var swiperMain = new Swiper(".mv-swiper", {
    slidesPerView: 1,
    loop: true,
    speed: 2000,
    loopAdditionalSlides: 2,
    loopedSlides: 1,
    effect: 'fade', 
      fadeEffect: {
    crossFade: true
  },
    disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
    grabCursor: false,
    autoplay: { // 自動再生
    delay: 2000, // 1.5秒後に次のスライド
    disableOnInteraction: false,
  },
    });


const sliders = document.querySelectorAll(".slider-ball");
const delays = [0, 100, 200]; // ← ずらす時間(ms)

sliders.forEach((slider, i) => {
  new Swiper(slider, {
    slidesPerView: 1,
    loop: true,
    speed: 1000,
    loopAdditionalSlides: 2,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    grabCursor: false,
    autoplay: {
      delay: 1500 + delays[i], // ←ここでずらす
      disableOnInteraction: false,
    },
  });
});

    var swipercafe = new Swiper(".cafe-swiper", {
    slidesPerView: 'auto',
    loopAdditionalSlides  : 10, // 1以上を指定
    loopedSlides: 40,
    loop: true,
        spaceBetween: 100,
      navigation: {
    nextEl: '.js-cafe-next',
    prevEl: '.js-cafe-prev',
  },
    pagination: {
    el: '.js-cafe-pagination', // ページネーション要素のクラス
    clickable: true, // クリックによるスライド切り替えを有効にする
    type: 'bullets' // 'bullets'（デフォルト） | 'fraction' | 'progressbar'
  },
    });

  var swipermarche = new Swiper(".marche-swiper", {
    slidesPerView: 'auto',
    loop: true,
    spaceBetween: 100,
/*     centeredSlides: false, */
speed: 1000,
    loopAdditionalSlides  : 5, // 1以上を指定
loopedSlides: 4,
    disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
    grabCursor: false,
      navigation: {
    nextEl: '.js-marche-next',
    prevEl: '.js-marche-prev',
  },
      pagination: {
    el: '.js-marche-pagination', // ページネーション要素のクラス
    clickable: true, // クリックによるスライド切り替えを有効にする
    type: 'bullets' // 'bullets'（デフォルト） | 'fraction' | 'progressbar'
  },
    });


};
//矢印の高さ合わせ
function updateMainImageHeight() {
  const firstImg = document.querySelector('.cafe-card-img img');
  if (!firstImg || !firstImg.complete) return;
  console.log(firstImg);

  const height = firstImg.clientHeight / 2 + 30;
  console.log(height);
  // 全カードに同じ高さを適用
  document.querySelectorAll('.cafe-slider-arrow').forEach(card => {
    card.style.setProperty('top', height + 'px');
  });
}

// ページロード時に実行
window.addEventListener('load', updateMainImageHeight);

// 画面サイズ変更時にも再取得（デバウンス付き）
window.addEventListener('resize', () => {
  clearTimeout(window._resizeTimer);
  window._resizeTimer = setTimeout(updateMainImageHeight, 150);
});

jQuery(function() {
  // スクロール判定
  jQuery(window).on("scroll", function() {
    let scrollTop = jQuery(this).scrollTop();
    let windowHeight = jQuery(this).height();
    let mvHeight = jQuery(".mv").height();
    let documentHeight = jQuery(document).height();

    if (mvHeight < scrollTop) {
      jQuery("body").attr("data-scroll", "true");
    } else {
      jQuery("body").attr("data-scroll", "false");
    }

  });
});

jQuery(function($){
  $('.topics-categorys.all').on('click', 'a', function(e){
    e.preventDefault();
    e.stopImmediatePropagation(); // 他のハンドラが動くのも防ぐ

    var $a    = $(this);
    jQuery('.topics-categorys.all a').removeClass('is-current');
    $a.addClass('is-current').siblings().removeClass('is-current');
    var $li   = $a.parent();
    var $curr = $('.topics-list.active');
    var $next = $($a.data('target')); // ← ハッシュではなく data-target

    if (!$next.length || $curr[0] === $next[0]) return;

    $li.addClass('active').siblings().removeClass('active');

    $curr.removeClass('active').fadeOut(200, function(){
      $next.css('display','grid').hide().addClass('active').fadeIn(200);
    });

    return false; // 念押し
  });
});
